import React, { PureComponent } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input
} from "reactstrap";
import axios from "axios";
import SearchBusinesses from "../SearchBusinesses";

const INITIAL_STATE = {
  selectedRole: null,
  isInviting: false,
  business: null,
  error: null
};

class UserInvitationModal extends PureComponent {
  constructor(props) {
    super(props);
    this.state = INITIAL_STATE;
    this.onRoleSelect = this.onRoleSelect.bind(this);
    this.onBusinessSelect = this.onBusinessSelect.bind(this);
    this.invite = this.invite.bind(this);
    this.close = this.close.bind(this);
  }

  onBusinessSelect(business) {
    return e => {
      e.stopPropagation();
      this.setState({ business });
    };
  }

  onRoleSelect(e) {
    this.setState({ selectedRole: e.target.value });
  }

  invite() {
    const token = sessionStorage.getItem("token");
    const payload = {
      name: this.state.selectedRole
    };

    if (this.state.business) {
      payload.entityId = this.state.business.id;
    }

    this.setState({ isInviting: true, error: null });
    axios
      .put(
        `/api/proxy/v2/users/${this.props.user.id}/permisgroups/invite`,
        payload,
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then(() => {
        this.setState({
          isInviting: false,
          selectedRole: null,
          business: null
        });
        this.props.onSuccess();
      })
      .catch(err => {
        this.setState({ error: err.response.data.error });
        this.setState({ isInviting: false });
        if (this.props.onCompletion) {
          this.props.onCompletion();
        }
      });
  }
  close() {
    this.props.close();
    this.setState({ ...INITIAL_STATE });
  }

  render() {
    return this.props.user ? (
      <Modal
        isOpen={this.props.open}
        toggle={this.toggle}
        className={this.props.className}
      >
        <ModalHeader toggle={this.close}>Invite User</ModalHeader>
        <ModalBody>
          <FormGroup>
            {this.state.error && (
              <p style={{ color: "red", marginBottom: 0 }}>
                {this.state.error}
              </p>
            )}
            <Label>New Role</Label>
            <Input
              type="select"
              className="form-control"
              onChange={this.onRoleSelect}
            >
              <option
                selected={this.state.selectedRole === null}
                default
                value={null}
              >
                Select a Role
              </option>
              <option value="SuperAdmin">SuperAdmin</option>
              <option value="Admin">Admin</option>
              <option value="Publisher">Publisher</option>
            </Input>
          </FormGroup>
          {this.state.selectedRole === "Publisher" && [
            this.state.business && (
              <p key="p">
                <span style={{ fontWeight: "bold" }}>Selection:</span>{" "}
                {this.state.business.name}
              </p>
            ),
            <SearchBusinesses key="search" onSelect={this.onBusinessSelect} />
          ]}
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={this.invite}>
            {this.state.isInviting && (
              <i
                className="fa fa-circle-o-notch fa-spin"
                style={{ marginRight: 5 }}
              />
            )}
            Invite
          </Button>{" "}
          <Button color="secondary" onClick={this.toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    ) : null;
  }
}

export default UserInvitationModal;



// WEBPACK FOOTER //
// ./src/views/Pages/Users/UserInvitationModal.js